import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "label", "expandable", "children"];
import React, { useMemo } from 'react';
import classnames from 'classnames';
import { createUseStyles, Section as SectionHoi } from 'hoi-poi-ui';
import PropTypes from 'prop-types';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'Section');
function Section(_ref) {
  let {
      className,
      label,
      expandable,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const headerClasses = useMemo(() => ({
    header: classes.header
  }), [classes.header]);
  return /*#__PURE__*/React.createElement(SectionHoi, {
    className: classnames(classes.root, className),
    title: label,
    isExpandable: expandable,
    classes: headerClasses
  }, children);
}
process.env.NODE_ENV !== "production" ? Section.propTypes = {
  label: PropTypes.string,
  expandable: PropTypes.bool,
  uiGrid: PropTypes.string
} : void 0;
export default /*#__PURE__*/React.memo(Section);